export const CUSTOM_VALIDATION_ERROR_CLASS = 'custom-validation-error';
